/**
 * @author: Sara Nouh
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-06-05
 * @description Implementation of the RadicalVisionary component.
 * @filename radical-visionary.tsx
 */
import React from "react";
import LazyLoad from 'react-lazyload';
import ProgressiveImage from "react-progressive-image";
const statistics = require("../../../static/Stats_test.png");

/**
 * The props of the RadicalVisionary component,
 */

interface RadicalVisionaryProps {
  /**
   * the json prop object from the backend
   */
  json: {
    /**
     * the logo mediaAsset ID
     *
     * @type {any}
     */
    previews?: [];

    /**
     * the footer mediaAsset ID
     *
     * @type {any}
     */
    footer?: [];
    /**
     * the Description of the Panel
     *
     * @type {string}
     */
    description?: string;
    /**
     * the Alignment of the Component
     *
     * @type {string}
     */
    componentAlignment?: string;
  };
}

/**
 *  A React component that renders the on* Marketing panel.
 *
 * @export
 * @class MarktingSlot
 * @extends {React.Component<MarktingSlotProps>}
 */
export class RadicalVisionary extends React.Component<RadicalVisionaryProps> {
  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    // ... should handle if not id provided from backend so it raise an error
    let imageSrc: string;
    let statisticsSrc: string;
    if (
      this.props.json &&
      this.props.json.previews !== null &&
      this.props.json.previews !== undefined
    ) {
      imageSrc = this.props.json.previews["LOGO"];
      statisticsSrc = this.props.json.footer["mediaAsset"];
      return (
        <div className="container-fluid on-control xxtra">
          <div
            className={
              this.props.json.componentAlignment === "CENTER"
                ? "flex-center"
                : "flex-left"
            }
          >
            {imageSrc ? (
              <div className="compaign-logo">
                <LazyLoad once={true} >
<ProgressiveImage src={imageSrc} placeholder={imageSrc}>
                  {(src: any, LOADING: any, srcSetData: any) => (
                    <img loading="lazy" alt="SHEconomics" className="xxtra-logo" src={src} />
                  )}
                </ProgressiveImage>
      </LazyLoad>

              </div>
            ) : null}
            <div className="campain-Intro">
              {this.props.json.description ? (
                <p>{this.props.json.description}</p>
              ) : null}
              {statisticsSrc ? (
                <LazyLoad once={true} >
<ProgressiveImage
                  src={statisticsSrc}
                  placeholder={statisticsSrc}
                >
                  {(src: any, LOADING: any, srcSetData: any) => (
                    <img loading="lazy" alt="SHEconomics" className="statistics" src={src} />
                  )}
                </ProgressiveImage>
      </LazyLoad>

              ) : null}
              {this.props.json.footer["text"] ? (
                <p>{this.props.json.footer["text"]}</p>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="on-control xxtra craySection">
        <div
          className={
            this.props.json.componentAlignment === "CENTER"
              ? "flex-center blackBGWhiteText"
              : "flex-left"
          }
        >
          <div className="campain-Intro">
            {this.props.json.description ? (
              <p>{this.props.json.description}</p>
            ) : null}
          </div>
          {/* <div className="monaIntro">
              <video className="video-js " controls={false} preload="auto">
                <source src="" type="application/x-mpegURL" />
              </video>
            </div> */}
        </div>
      </div>
    );
  }
}
